import React, { useEffect, useState } from "react"
import { FastField, Formik, useFormikContext } from "formik"

import FormError from "../../../formError"

const BusinessInfo = () => {
  const { errors, touched } = useFormikContext()
  const [st, setSt] = useState([])
  const [countries, setCountries] = useState([])
  const [categories, setCategories] = useState([])
  const [businessNature, setBusinessNature] = useState([])

  const getStates = () => {
    fetch(`${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/kyc/states`)
      .then((response) => response.json())
      .then((data) => setSt(data.data))
  }

  const getCountries = () => {
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/Countries`)
      .then((response) => response.json())
      .then((data) => {
        setCountries(data)
      })
  }

  const getBusinessNatures = () => {
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/BusinessNatures`)
      .then((response) => response.json())
      .then((data) => {
        setBusinessNature(data)
      })
  }

  const getCategories = () => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    }

    fetch(
      `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/web/product-categories`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        let sorted = data.data?.filter(
          (x) => x.product === "Company Incorporation"
        )
        // setIsLoading(false)
        setCategories(sorted)
      })
      .catch((error) => console.log("error", error))

  }

  useEffect(() => {
    getStates()
    getCountries()
    getCategories()
  }, [])

  return (
    <>
      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="suffix">Suffix</label>
          <FastField
            className="form-control custom-select"
            as="select"
            id="suffix"
            name="suffix" 
          >
            <option value="">Select Suffix</option>
            <option value="Ltd">Ltd</option>
            <option value="Limited">Limited</option>
          </FastField>

          <FormError touched={touched.suffix} message={errors.suffix} />
        </div>
      </div>
      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="preferred_name1"> Business Name Sample 1</label>
          <FastField
            type="text"
            className="form-control"
            id="preferred_name1"
            name="preferred_name1"
          />

          <FormError
            touched={touched.preferred_name1}
            message={errors.preferred_name1}
          />
        </div>

        <div className="form-group col-md-5">
          <label htmlFor="preferred_name2"> Business Name Sample 2</label>
          <FastField
            type="text"
            className="form-control"
            id="preferred_name2"
            name="preferred_name2"
          />

          <FormError
            touched={touched.preferred_name2}
            message={errors.preferred_name2}
          />
        </div>
      </div>
      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="preferred_name3"> Business Name Sample 3</label>
          <FastField
            type="text"
            className="form-control"
            id="preferred_name3"
            name="preferred_name3"
          />

          <FormError
            touched={touched.preferred_name3}
            message={errors.preferred_name3}
          />
        </div>

        <div className="form-group col-md-5">
          <label htmlFor="preferred_name4"> Business Name Sample 4</label>
          <FastField
            type="text"
            className="form-control"
            id="preferred_name4"
            name="preferred_name4"
          />

          <FormError
            touched={touched.preferred_name4}
            message={errors.preferred_name4}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group col-md-12">
          <label htmlFor="business_nature">Business Nature</label>
          <FastField
            className="form-control"
            id="business_nature"
            name="business_nature"
          />

          <FormError
            touched={touched.business_nature}
            message={errors.business_nature}
          />
        </div>
      </div>

      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="category">Category</label>
          <FastField
            className="form-control custom-select"
            as="select"
            id="category"
            name="category"
          >
            <option value="">---------</option>
            {categories.map((category, index) => (
              <option key={index} value={category.id}>
                {category.name}
              </option>
            ))}
          </FastField>

          <FormError touched={touched.category} message={errors.category} />
        </div>

        <div className="form-group col-md-5">
          <label htmlFor="country">Country</label>
          <FastField
            className="form-control custom-select"
            as="select"
            id="country"
            name="country"
          >
            <option value="">Select Country</option>
            {countries.map((country) => (
              <option key={country.value} value={country.value}>
                {country.display}
              </option>
            ))}
          </FastField>

          <FormError touched={touched.country} message={errors.country} />
        </div>
      </div>

      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="state">State</label>
          <FastField
            className="form-control custom-select"
            as="select"
            id="state"
            name="state"
          >
            <option value="">Select State</option>
            {st &&
              st.map((data) => (
                <option key={data.id} value={data.name}>
                  {data.name}
                </option>
              ))}
          </FastField>

          <FormError touched={touched.state} message={errors.state} />
        </div>

        <div className="form-group col-md-5">
          <label htmlFor="city">City</label>
          <FastField
            type="text"
            className="form-control"
            id="city"
            name="city"
          />

          <FormError touched={touched.city} message={errors.city} />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group col-md-12">
          <label htmlFor="address">Business address</label>
          <FastField
            className="form-control"
            id="address"
            name="address"
            as="textarea"
          />

          <FormError touched={touched.address} message={errors.address} />
        </div>
      </div>

      {/* <div className="form-row justify-content-center">
        <div className="form-group col-md-12">
          <label htmlFor="share_capital">Share capital</label>
          <FastField
            className="form-control"
            id="share_capital"
            name="share_capital"
          />

          <FormError
            touched={touched.share_capital}
            message={errors.share_capital}
          />
        </div>
      </div> */}
    </>
  )
}
export default BusinessInfo
